export const HEADER = {
    logout: "Déconnexion",
    cart: "Mon panier",
    dont: "Dont",
    buttonCumul: "Cumul régies groupe Casino",
    budgetRegie: "Budget par régie",
    budgetGroupe: "Budget groupe : ",
    columnNewPanneau: "Nouveaux panneaux",
    columnOldPanneau: "Panneaux sous contrat",
    columnRegie: "Régie",
    columnBudgetNTHTNew: "Budget net HT",
    columnBudgetNTHTOld: "Budget net HT",
    columnTlpeNew: "TLPE",
    columnTlpeOld: "TLPE",
    columnTotal: "Total",
    buttonFermer: "Fermer",
    buttonExportPDV: "Export Point de vente",
    buttonExportPan: "Export Panneaux",
    buttonExportRegie: "Export Tableau",
    vide: 'Vide',
    sousContrat: 'sous contrat',
    viderPanier: {
      tooltip: "Vider le panier",
      titre: "Voulez-vous vraiment vider votre panier? ",
      message: "Les modifications en cours seront définitivement perdues",
      non: "Non",
      oui: "Oui",
    },
};
